<div class="text-center inactive">
  <div class="inactive-img">
  <img src='assets/img/Inactive.svg'/>
  </div>
  <div class="text-blue-600 font-weight-semibold mt-3 mb-2">
    {{'Sorry' | translate }} !
  <br />
    {{'YourAccountIsInactive' | translate }}
  </div>
  <div class="text-grey-600">
    {{'PleaseContactYourAdministratorToHandelThis' | translate }}.
  </div>
 </div>